import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { Observable, of, throwError } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { ItemMin } from '../entites/item-min';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { Item } from '../entites/item';
import { BonCommandeEntite } from '../entites/bon-commande';
import { ItemBonCommande } from '../entites/item-bon-commande';
import { RequeteTransfererVersCtrl } from './requetes/requete-transfert-ctrl';
import { ItemService } from './item-service';
import { ClientEntite } from '../entites/client';
import { BaseService, CacheMap } from './base.service';
import { ProfilService } from './profil-service';
import { DonneesBaseService } from './donnees-base-service';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { ReponseFiltre } from './reponses/reponse-filter';
@Injectable({ providedIn: 'root' })
export class AchatService extends BaseService {

  private bonCommandeUrl = environment.apiBaseUrl + 'achat/bonsCommande';
  private bonCommandeSeulUrl = environment.apiBaseUrl + 'achat/bonsCommande/{bonCommandeId}';
  private obtenirDetailUrl = environment.apiBaseUrl + 'achat/bonsCommande/{bonCommandeId}';
  private modifierChampUrl = environment.apiBaseUrl + 'achat/bonsCommande/{id}/champ';
  private itemBonCommandeUrl = environment.apiBaseUrl + 'achat/bonsCommande/item';
  private obtenirNumeroCtrlUrl = environment.apiBaseUrl + 'achat/bonsCommande/obtenirNumeroCTRL';
  private transfererVersCtrlUrl = environment.apiBaseUrl + 'achat/bonsCommande/transfertCTRL';
  private obtenirHsitoriqueItemUrl = environment.apiBaseUrl + 'achat/historiqueItem/{itemId}';
  private obtenirBonCommandeOuvertFournisseurUrl = environment.apiBaseUrl + 'achat/bonsCommandeOuvert/{fournisseurId}/{employeId}';
  private obtenirBonCommandeLocationOuvertFournisseurUrl = environment.apiBaseUrl + 'achat/bonsCommandeLocationOuvert/{fournisseurId}/{employeId}';
  private obtenirDetailClientUrl = environment.apiBaseUrl + 'achat/client/{id}';
  private corrigerBonCommandeUrl = environment.apiBaseUrl + 'achat/bonsCommande/corriger';
  private obtenirHistoriqueAchatPiecesUrl = environment.apiBaseUrl + 'achat/historiqueachatpieces/{uniteId}';
  private completerBonCommandeUrl = environment.apiBaseUrl + 'achat/bonCommande/completer';
  private obtenirForcerSynchronisationCTRLUrl = environment.apiBaseUrl + 'ctrl/synchro';
  private termesPaiementUrl = environment.apiBaseUrl + 'achat/bonsCommande/termesPaiment';
  private obtenirClientsUrl = environment.apiBaseUrl + 'achat/clients';

  private cacheMapBonsCommande = new CacheMap<string, Observable<ReponseFiltre<BonCommandeEntite>>>();

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    public itemService: ItemService,
    private http: HttpClient,
    public router: Router,
    public messageService: MessageService,
    public profilService: ProfilService
  ) { 
    super(messageService, router);
  }

  public ObtenirBonsCommande(statutId: number, employeId: number, rechercheComplete: boolean, event: LazyLoadEvent): Observable<ReponseFiltre<BonCommandeEntite>> {
    const cacheKey = `${statutId}-${employeId}-${rechercheComplete}-${JSON.stringify(event)}`;
    var params = new HttpParams();
    if (!this.cacheMapBonsCommande.has(cacheKey)) {
      params = this.GenerateFilterParams(event);

    if (statutId) {
      params = params.set('statutId', statutId.toString());
    }
    if (employeId) {
      params = params.set('employeId', employeId.toString());
    }
    if (rechercheComplete) {
      params = params.set('rechercheComplete', rechercheComplete.toString());
    }

    var p = this.http.get<ReponseFiltre<BonCommandeEntite>>(this.bonCommandeUrl, { params })
    .pipe(
      catchError(error => {
        this.handleError(error);
        this.cacheMapBonsCommande.delete(cacheKey);
        throw error;
      }),
      shareReplay()
    );
    
    this.cacheMapBonsCommande.set(cacheKey, p);
  }

    return this.cacheMapBonsCommande.get(cacheKey)!;
  }

  public ObtenirHistoriqueItem(itemId: number): Promise<ReponseBase<ItemBonCommande[]>> {
    var p = this.http.get<ReponseBase<ItemBonCommande[]>>(this.obtenirHsitoriqueItemUrl.replace('{itemId}', itemId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirHistoriqueAchatPieces(uniteId: number): Promise<ReponseBase<ItemBonCommande[]>> {
    var p = this.http.get<ReponseBase<ItemBonCommande[]>>(this.obtenirHistoriqueAchatPiecesUrl.replace('{uniteId}', uniteId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public RendreBonsCommandePrivesLot(bonCommandeIds: number[], indPrive = true): Promise<ReponseBase<{ nombreTraites: number; bonCommandeIdsTraites: number[]; bonCommandeIdsIgnores: number[] }>> {
    var p = this.http.post<ReponseBase<{ nombreTraites: number; bonCommandeIdsTraites: number[]; bonCommandeIdsIgnores: number[] }>>(
      this.bonCommandeUrl + '/prive/lot',
      JSON.stringify({ bonCommandeIds, indPrive }),
      this.httpOptions
    ).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public SupprimerBonCommande(bonCommandeId: number): Promise<ReponseBase<boolean>> {
    var p = this.http.delete<ReponseBase<boolean>>(this.bonCommandeSeulUrl.replace('{bonCommandeId}', bonCommandeId.toString()), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public SupprimerItemsBonCommande(bonCommandeIds: number[]): Promise<ReponseBase<boolean>> {
    var params = new HttpParams().appendAll({ ids: bonCommandeIds });
    var p = this.http.delete<ReponseBase<boolean>>(this.itemBonCommandeUrl, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), params }).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public CreerBonCommande(requete: BonCommandeEntite): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.bonCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    

    return p;
  }

  public CreerItemBonCommande(requete: ItemBonCommande): Promise<ReponseBase<ItemBonCommande>> {
    var p = this.http.post<ReponseBase<ItemBonCommande>>(this.itemBonCommandeUrl, JSON.stringify(requete), this.httpOptions)
    .pipe(
      catchError(error => {
        this.handleError(error);
        throw error;
      })
    )
    .toPromise();
    return p;
  }

  public ModifierItemBonCommande(requete: ItemBonCommande): Promise<ReponseBase<ItemBonCommande>> {
    var p = this.http.put<ReponseBase<ItemBonCommande>>(this.itemBonCommandeUrl, JSON.stringify(requete), this.httpOptions)
    .pipe(
      catchError(error => {
        this.handleError(error);
        throw error;
      })
    )
    .toPromise();
    return p;
  }

  public CorrigerBonCommande(requete: BonCommandeEntite): Promise<ReponseBase<BonCommandeEntite>> {
    var p = this.http.post<ReponseBase<BonCommandeEntite>>(this.corrigerBonCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirNumeroCtrl(bonCommandeId: number): Promise<ReponseBase<string>> {
    var p = this.http.post<ReponseBase<string>>(this.obtenirNumeroCtrlUrl, JSON.stringify(bonCommandeId), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public TransfererVersCtrl(requete: RequeteTransfererVersCtrl): Promise<ReponseBase<string>> {
    var p = this.http.post<ReponseBase<string>>(this.transfererVersCtrlUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    

    return p;
  }

  public ObtenirBonCommande(bonCommandeId: number): Promise<ReponseBase<BonCommandeEntite>> {
    var p = this.http.get<ReponseBase<BonCommandeEntite>>(this.obtenirDetailUrl.replace('{bonCommandeId}', bonCommandeId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }


  public ModifierBonCommande(requete: BonCommandeEntite): Promise<ReponseBase<BonCommandeEntite>> {
    var p = this.http.put<ReponseBase<ItemBonCommande>>(this.bonCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  /**
   * Patche un champ d'en-tête du bon de commande (édition inline).
   */
  public ModifierChamp(id: number, champ: string, valeur: any): Observable<ReponseBase<BonCommandeEntite>> {
    return this.http.patch<ReponseBase<BonCommandeEntite>>(
      this.modifierChampUrl.replace('{id}', id.toString()),
      JSON.stringify({ champ, valeur }),
      this.httpOptions
    ).pipe(catchError(error => this.handleError(error)));
  }


  public CompleterBonCommandeSansTransfertCtrl(requete: BonCommandeEntite): Promise<ReponseBase<BonCommandeEntite>> {
    var p = this.http.post<ReponseBase<ItemBonCommande>>(this.completerBonCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirBonCommandeOuvertFournisseur(fournisseurId: number, employeId: number): Promise<ReponseBase<BonCommandeEntite>> {
    var p = this.http.get<ReponseBase<BonCommandeEntite>>(this.obtenirBonCommandeOuvertFournisseurUrl.replace('{fournisseurId}', fournisseurId.toString()).replace('{employeId}', employeId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirBonCommandeLocationOuvertFournisseur(fournisseurId: number, employeId: number): Promise<ReponseBase<BonCommandeEntite[]>> {
    var p = this.http.get<ReponseBase<BonCommandeEntite[]>>(this.obtenirBonCommandeLocationOuvertFournisseurUrl.replace('{fournisseurId}', fournisseurId.toString()).replace('{employeId}', employeId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirDetailClient(id: number): Observable<HttpResponse<ClientEntite>> {
    return this.http.get<ClientEntite>(this.obtenirDetailClientUrl.replace('{id}', id.toString()), { observe: 'response' });
  }

  public ForcerSynchronisationCTRL(): Observable<ReponseBase<boolean>> {
    return this.http.post<ReponseBase<boolean>>(this.obtenirForcerSynchronisationCTRLUrl, { simulation: false });
  }

  public ObtenirTermesPaiementPdf(): Observable<Blob> {
    return this.http.get(this.termesPaiementUrl, {
      responseType: 'blob'
    }).pipe(
      catchError(error => this.handleError(error))
    );
  }

  public ClearCacheBonsCommande(): void {
    this.cacheMapBonsCommande.clear();
  }

  public RemovePagesWithBonCommandeId(bonCommandeId: number): void {
    var liste = [];
    this.cacheMapBonsCommande.forEach((value, key) => {
      value.subscribe(x => {
        if (x.elements.some(y => y.bonCommandeId == bonCommandeId)) {
          liste.push(key);
        }
      });
    });
    liste.forEach(x => this.cacheMapBonsCommande.delete(x));
  }

  public AjouterTermesPaiementPdf(pdfFile: File): Observable<string> {
    if (!pdfFile || pdfFile.size === 0) {
      return throwError(() => new Error('Le fichier PDF est requis.'));
    }

    const formData = new FormData();
    formData.append('pdfFile', pdfFile);

    return this.http.post<string>(this.termesPaiementUrl, formData).pipe(
      map(() => 'Le fichier PDF a été ajouté/modifié avec succès.'),
      catchError(error => this.handleError(error))
    );
  }

  public ObtenirClients(): Observable<ClientEntite[]> {
    return this.http.get<ClientEntite[]>(this.obtenirClientsUrl).pipe(
      catchError(error => this.handleError(error))
    );
  }
}
